import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { centerDelegatedApi, type StartConsentInput, type VerifyConsentInput, type CreateDelegatedShipmentInput } from '@/api/centerDelegated';

export function useStartConsent() {
  return useMutation({
    mutationFn: (input: StartConsentInput) => centerDelegatedApi.startConsent(input),
  });
}

export function useVerifyConsent() {
  return useMutation({
    mutationFn: (input: VerifyConsentInput) => centerDelegatedApi.verifyConsent(input),
  });
}

export function useCreateDelegatedShipment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateDelegatedShipmentInput) => centerDelegatedApi.create(input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['delegated-shipments'] });
      void qc.invalidateQueries({ queryKey: ['shipments'] });
    },
  });
}

export function useDelegatedShipments(params?: { limit?: number; offset?: number }) {
  return useQuery({
    queryKey: ['delegated-shipments', 'mine', params?.limit, params?.offset],
    queryFn: () => centerDelegatedApi.listMine(params),
  });
}
